'use client';
import { useClientRender } from '#pplx/frontend/common/hooks/useClientRender.js';
import { memo } from 'react';
import { createPortal } from 'react-dom';
export const PortalPrimitive = memo(function PortalPrimitive({ children, targetElement, }) {
    const isClientRender = useClientRender();
    if (!isClientRender) {
        return null;
    }
    return createPortal(children, targetElement ?? document.body);
});
//# sourceMappingURL=index.js.map